exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.profile-background[data-v-377d0326]{background-color:silver\n}\n.cropper-banner[data-v-377d0326]{max-height:5000px;max-width:1100px;background-color:#ddd\n}", ""]);

// exports
